import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/utils/data.service';
import { RefundStatusRs } from '../../models/RefundStatusRs';
import { RefundStatusMessageCode } from '../../models/RefundStatusMessageCode';
import { TranslatorService } from 'src/app/modules/translator/providers/translator.service';
import { InterpolationService } from 'src/app/services/utils/interpolation.service';

@Component({
  selector: 'app-refund-status-refunded',
  templateUrl: './refund-status-refunded.component.html',
  styleUrls: ['./refund-status-refunded.component.css']
})
export class RefundStatusRefundedComponent implements OnInit {

  refundStatusRs: RefundStatusRs;
  isEmailProvided: boolean;
  isCCFOP: boolean;
  isUSD: boolean;

  // public translations: any;
  public pageData: any;

  constructor(private dataService: DataService,
              private translatorService: TranslatorService,
              private interpolatorService: InterpolationService) { }

  public isBeforeCutoffDate(refundIssueDate): boolean {
    return this.dataService.isBeforeCutoffDate(refundIssueDate);
  }

  ngOnInit() {
    this.getPageData();
    this.isEmailProvided = false;
    this.isCCFOP = false;
    this.isUSD = false;
    this.dataService.refundStatusRs.subscribe(
        (refundStatusRs) => {
        this.refundStatusRs = refundStatusRs;
        // check if email is provided
        if (this.refundStatusRs.refundStatus[0].passengerContact.email
            && this.refundStatusRs.refundStatus[0].passengerContact.email.trim().length > 0) {
            this.isEmailProvided = true;
        }

        // check if at least one CC FOP type exists
        this.refundStatusRs.refundStatus.forEach(function(value) {
            if (value.refundStatusMessageCode === RefundStatusMessageCode.AA
            || value.refundStatusMessageCode === RefundStatusMessageCode.AX
            || value.refundStatusMessageCode === RefundStatusMessageCode.DC
            || value.refundStatusMessageCode === RefundStatusMessageCode.DS
            || value.refundStatusMessageCode === RefundStatusMessageCode.JC
            || value.refundStatusMessageCode === RefundStatusMessageCode.MC
            || value.refundStatusMessageCode === RefundStatusMessageCode.VI
            || value.refundStatusMessageCode === RefundStatusMessageCode.UATP
            // || value.refundStatusMessageCode === RefundStatusMessageCode.ORIGINAL_FOP
            // || value.refundStatusMessageCode === RefundStatusMessageCode.PP
            // || value.refundStatusMessageCode === RefundStatusMessageCode.WC
            // || value.refundStatusMessageCode === RefundStatusMessageCode.CU
            // || value.refundStatusMessageCode === RefundStatusMessageCode.AL
            ) {
                this.isCCFOP = true;
                return;
            }
        }, this);
        // check if USD or Non-USD
        this.refundStatusRs.refundStatus.forEach(function(value) {
            if (value.refundCurrency === 'USD') {
                this.isUSD = true;
                return;
            }
        }, this);
        },
        error => {
        },
        () => {
        if (this.refundStatusRs.refundStatus[0].passengerContact.email
            && this.refundStatusRs.refundStatus[0].passengerContact.email.trim().length > 0) {
            this.isEmailProvided = true;
        }
        });
  }

  private getPageData() {
    const dataSet = new Map();
    this.pageData = this.interpolatorService
                        .interpolate(this.translatorService
                                    .getTranslations('refund-status'),
                                    dataSet);
  }

}
